import { render, staticRenderFns } from "./GradoAcademicoPage.vue?vue&type=template&id=2e9c65dc"
import script from "./GradoAcademicoPage.js?vue&type=script&lang=js&external"
export * from "./GradoAcademicoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports